import React from 'react';

import moment, { isMoment } from 'moment';

import {  SingleDatePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import LocaleAsString from '../../LocaleEngine/LocaleAsString';

import './index.scss';

export default function Type4(props) {
    const [ focused, setFocused ] = React.useState(false)

    const getInitialVisibleMonth = () => {
        if (props.date) return moment.utc(props.date);
        if (props.AgeCalculationBasisDate && props.minAge) return moment.utc(props.AgeCalculationBasisDate).subtract(props.minAge, "years");
        return moment.utc();
    }

    const returnYears = () => {
        let years = []
        for(let i = moment.utc().year() - 100; i <= moment.utc().year() + 1; i++) {
            years.push(<option value={i}>{i}</option>);
        }
        return years;
    }

    const placeHolder = () => {
        let placeholder = LocaleAsString(props.placeHolder);
        if (props.required) placeholder = placeholder + " *";
        placeholder = placeholder + " (MM/DD/YYYY)";

        return placeholder
    }
    const maxAge = props.maxAge
    const minAge = props.minAge

    return(
        <SingleDatePicker
            readOnly={props.readOnly || false}
            disabled={props.disabled || false}
            hideKeyboardShortcutsPanel={true}
            date={props.date !== undefined ? isMoment(props.date) ? props.date : moment.utc(props.date): undefined}
            isOutsideRange={date => { 
                if (!props.AgeCalculationBasisDate) return date < moment.utc();
                if (props.AgeCalculationBasisDate && !maxAge && !minAge) return date >= moment.utc();
                return date < moment.utc(props.AgeCalculationBasisDate).subtract(maxAge+1, 'years') || date > moment.utc(props.AgeCalculationBasisDate).subtract(minAge, 'years')
            }}
            onDateChange={date => props.handleChangeDate(date)}
            id="your_unique_id"
            numberOfMonths={1}
            focused={focused}
            onFocusChange={({ focused }) => setFocused(focused)} 
            placeholder={placeHolder()}
            keepOpenOnDateSelect={false}
            displayFormat={"MM/DD/YYYY"}
            withFullScreenPortal={props.withFullScreenPortal ? true : false}
            navNext={props.navNext}
            navPrev={props.navPrev}
            initialVisibleMonth={() => getInitialVisibleMonth()}
            renderMonthElement={({ month, onMonthSelect, onYearSelect }) =>
            <div className="selectsWrapper" style={{ display: 'flex', justifyContent: 'center' }}>
                <div>
                    <select
                        value={month.month()}
                        onChange={(e) => onMonthSelect(month, e.target.value)}
                    >
                        {moment.months().map((label, value) => {
                            return <option value={value}>{label}</option>
                        })}
                    </select>
                </div>
                <div>
                    <select value={month.year()} onChange={(e) => onYearSelect(month, e.target.value)}>
                        {returnYears()}
                    </select>
                </div>
            </div>
            }
        />
    )
}
